import React, { useEffect, useState } from 'react'
import employeeAnalyticsService from '../Services/employeeAnalyticsService';

const AttendanceStatsCards = ({selectedTeam , selectedDate}) => {

  const [stageCount, setStageCount] = useState({
    totalEmployee: 0,
    loggedIn: 0,  
    notLoggedIn: 0,
    absent: 0,
    lateCheckIn: 0,
    leave: 0
  });
  const statsData = [
    {
      id: 1,
      value: stageCount.totalEmployee,
      label: "Total Employee",
      bgColor: "bg-[#D2FAEC]"
    },
    {
      id: 2,
      value: stageCount.loggedIn, 
      label: "Logged In",
      bgColor: "bg-[#D3EEFF]"
    },
    {
      id: 3,
      value: stageCount.notLoggedIn,
      label: "Not Logged In", 
      bgColor: "bg-[#FFDDC0]"
    },
    {
      id: 4,
      value: stageCount.absent,
      label: "Absent",
      bgColor: "bg-[#FFB7B7]"
    },
    {
      id: 5,
      value: stageCount.lateCheckIn,
      label: "Late check-in",
      bgColor: "bg-[#FFFBDF]"
    },
    {
      id: 6,
      value: stageCount.leave, 
      label: "Leave",
      bgColor: "bg-[#D5CBFF]"
    }
  ]

  const fetchStageCount = async () => {
    try {
      const response  = await employeeAnalyticsService.employeeCardCount({
        teamId: selectedTeam?.value || "",
        date: selectedDate 
      })
  
      if (response && response.data) {
        const data = response.data;
        setStageCount({
          totalEmployee: data.totalEmployee || 0,
          loggedIn: data.totalLoggedIn || 0,
          notLoggedIn: data.totalNotLoggedIn || 0,
          absent: data.totalAbsent || 0,
          lateCheckIn: data.totalLateCheckIn || 0,
          leave: data.totalLeave || 0
        });
      }

    }catch (error) {
      console.error("Error fetching stage count:", error);
    }
  }

  useEffect(()=>{
    fetchStageCount()
  },[selectedTeam , selectedDate])

  return (
    <div className="grid grid-cols-4 md:grid-cols-12 gap-4 mb-6">
      {statsData.map(stat => (
        <div 
          key={stat.id} 
          className={`${stat.bgColor} h-[129px] flex flex-col  rounded-xl px-4 py-6 gap-4 col-span-5 md:col-span-2 shadow-sm border border-gray-100`}
        >
          <div className="text-[24px] font-semibold text-gray-800 mb-2 ">
            {stat.value}
          </div>
          <div className="text-[16px] text-gray-600 font-medium ">
            {stat.label}
          </div>
        </div>
      ))}
    </div>
  )
}

export default AttendanceStatsCards